import React from 'react';
import CutFileTable from "../../../../components/UI/table/cut-file/CutFileTable";
import {useLocation, useParams} from "react-router-dom";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";

const CutFile = () => {

    const params = useParams();
    const location = useLocation();
    const fromArchive = new URLSearchParams(location.search).get("from") === "archive";

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Файлы"}
                path={[
                    {name: "Главная", href: "/"},
                    fromArchive
                        ? {name: "Карты раскроя", href: "/organization/working-cutting-maps"}
                        : {name: "Порядок раскроя", href: "/organization/queue-cutting-maps"},
                    ...(fromArchive
                        ? [{name: "Архив карт раскроя", href: "/organization/working-cutting-maps-archive"}]
                        : []),
                ]}/>
            <CutFileTable
                cuttingMapId={params.workingCuttingMapId}
                nameMaterial={params.nameMaterial}
            />
        </Box>
    );
};

export default CutFile;